import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateRegistrationFormMessage($formId: Int!, $content: String){
    createRegistrationFormMessage(
      input:{
        form_id: $formId,
        content: $content
      }
    )
    {
      id
      form_id
      content
    }
  }
`;
